import { Droplet, Flame, Truck, BarChart3, CheckCircle, Clock, Award, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { lazy, Suspense } from 'react'
import SEO from '../components/SEO'
import { serviceSEOData } from '../utils/serviceSEO'

// ✅ Import images to ensure they work in production
import hero1 from '../assets/Services/oil-fuel-supply/hero-1.jpg'
import hero2 from '../assets/Services/oil-fuel-supply/hero-2.jpg'
import hero3 from '../assets/Services/oil-fuel-supply/hero-3.jpg'
import fuelDistImg from '../assets/Services/oil-fuel-supply/fuel-distribution.jpg'
import storageImg from '../assets/Services/oil-fuel-supply/storage.jpg'
import qualityImg from '../assets/Services/oil-fuel-supply/quality-testing.jpg'
import bulkImg from '../assets/Services/oil-fuel-supply/bulk-supply.jpg'
import emergencyImg from '../assets/Services/oil-fuel-supply/emergency.jpg'

const ServicePageLayout = lazy(() => import('../components/ServicePageLayout'))

const OilFuelSupply = () => {
  const { t } = useTranslation()
  
  const service = {
    heroSlides: [
      {
        image: hero1, // ✅ Use imported variable
        title: t('oilFuelSupply.heroSlides.0.title'),
        subtitle: t('oilFuelSupply.heroSlides.0.subtitle'),
        description: t('oilFuelSupply.heroSlides.0.description')
      },
      {
        image: hero2,
        title: t('oilFuelSupply.heroSlides.1.title'),
        subtitle: t('oilFuelSupply.heroSlides.1.subtitle'),
        description: t('oilFuelSupply.heroSlides.1.description')
      },
      {
        image: hero3,
        title: t('oilFuelSupply.heroSlides.2.title'),
        subtitle: t('oilFuelSupply.heroSlides.2.subtitle'),
        description: t('oilFuelSupply.heroSlides.2.description')
      }
    ],
    introText: t('oilFuelSupply.introText'),
    stats: [
      { value: "100%", label: t('oilFuelSupply.stats.reliability') },
      { value: "24/7", label: t('oilFuelSupply.stats.operations') },
      { value: "ISO", label: t('oilFuelSupply.stats.certified') },
      { value: t('oilFuelSupply.stats.zero'), label: t('oilFuelSupply.stats.incidents') }
    ],
    capabilities: t('oilFuelSupply.capabilities', { returnObjects: true }),
    services: [
      {
        icon: Flame,
        title: t('oilFuelSupply.services.drillingExploration.title'),
        description: t('oilFuelSupply.services.drillingExploration.description'),
        image: fuelDistImg // ✅ Use imported variable
      },
      {
        icon: BarChart3,
        title: t('oilFuelSupply.services.productionOptimization.title'),
        description: t('oilFuelSupply.services.productionOptimization.description'),
        image: storageImg
      },
      {
        icon: CheckCircle,
        title: t('oilFuelSupply.services.facilitiesMaintenance.title'),
        description: t('oilFuelSupply.services.facilitiesMaintenance.description'),
        image: qualityImg
      },
      {
        icon: Award,
        title: t('oilFuelSupply.services.reliabilitySafety.title'),
        description: t('oilFuelSupply.services.reliabilitySafety.description'),
        image: bulkImg
      },
      {
        icon: Droplet,
        title: t('oilFuelSupply.services.customizedSolutions.title'),
        description: t('oilFuelSupply.services.customizedSolutions.description'),
        image: emergencyImg
      }
    ],
    workflow: [
      {
        step: "01",
        title: t('oilFuelSupply.workflow.0.title'),
        description: t('oilFuelSupply.workflow.0.description')
      },
      {
        step: "02",
        title: t('oilFuelSupply.workflow.1.title'),
        description: t('oilFuelSupply.workflow.1.description')
      },
      {
        step: "03",
        title: t('oilFuelSupply.workflow.2.title'),
        description: t('oilFuelSupply.workflow.2.description')
      },
      {
        step: "04",
        title: t('oilFuelSupply.workflow.3.title'),
        description: t('oilFuelSupply.workflow.3.description')
      }
    ]
  }

  return (
    <>
      <SEO {...serviceSEOData['oil-fuel-supply']} url="/services/oil-fuel-supply" />
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <ServicePageLayout
        title={service.heroSlides[0].title}
        subtitle={service.heroSlides[0].subtitle}
        description={service.heroSlides[0].description}
        backgroundImages={service.heroSlides.map(slide => slide.image)}
        heroSlides={service.heroSlides}
        introText={service.introText}
        capabilities={service.capabilities}
        services={service.services}
        stats={service.stats}
        workflow={service.workflow}
        />
      </Suspense>
    </>
  )
}

export default OilFuelSupply